import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSuperuserComponent } from './simple-icons-superuser.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSuperuserComponent ],
    exports:      [ SimpleIconsSuperuserComponent ],
    bootstrap:    []
})
export class SimpleIconsSuperuserModule {}
